import styled from 'styled-components';

import { size } from '../../layout/helpers';
import { Button } from '../Button';
import { Icon } from '../Icon';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${size(1.5)};
`;

export const StepButton = styled(Button).attrs(() => ({
  $tone: 'secondary',
}))`
  flex-shrink: 0;
  padding-left: ${size(3)};
  padding-right: ${size(3)};
  font-size: ${size(2.5)};
`;

export const QuickNav = styled.div`
  position: relative;
  width: max-content;
  cursor: pointer;
  min-width: 0;
`;

export const QuickNavDummy = styled.div`
  --padding-inline: ${size(4)};

  ${(props) => props.theme.breakpoint.LtSm} {
    --padding-inline: ${size(3)};
  }

  display: flex;
  align-items: center;
  gap: ${size(0.5)};
  min-height: ${size(5.5)};
  padding: ${size(1)} var(--padding-inline);
  background-color: var(--c-secondary-bg);
  color: var(--c-secondary-fg);
  border-radius: ${size(2.75)};
  font-size: ${(props) => props.theme.font.size.small};
  font-weight: var(--font-weight-bold);
  line-height: 1;

  ${Icon} {
    flex-shrink: 0;
    font-size: ${size(2.5)};
  }
`;

export const QuickNavTitle = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const QuickNavSelect = styled.select`
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;

  &[disabled] {
    cursor: not-allowed;
  }
`;

export const QuickNavOption = styled.option`
  color: var(--c-text-main);
`;
